"use client";

import { useRole } from "@/contexts/role-context";

export function RolePlaceholder({ title }: { title: string }) {
  const { roleConfig } = useRole();

  return (
    <div className="rounded-xl border bg-card p-6">
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        This experience is coming soon for the {roleConfig.label} role.
      </p>
    </div>
  );
}
